import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;

const HubSpotTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view cuando la ubicación cambia
    if (window._hsq) {
      window._hsq.push(['setPath', location.pathname]);
      window._hsq.push(['trackPageView']);
    }
  }, [location]);

  useEffect(() => {
    // Verificar que tenemos el portal ID
    if (!portalId) {
      console.warn("HubSpot Portal ID no configurado");
      return;
    }

    // Si ya está cargado, no hacer nada
    if (window.hbspt) {
      return;
    }

    // Inicializar el array de HubSpot
    window._hsq = window._hsq || [];

    // Solo cargar el script si no existe
    if (!document.getElementById("hs-script-loader")) {
      const script = document.createElement("script");
      script.id = "hs-script-loader";
      script.async = true;
      script.defer = true;
      script.src = `//js.hs-scripts.com/${portalId}.js`;
      
      script.onload = () => {
        console.log("HubSpot script cargado correctamente");
      };
      
      script.onerror = () => {
        console.error("Error al cargar el script de HubSpot");
      };

      document.head.appendChild(script);
    }

    return () => {
      // No limpiar el script en el cleanup para mantener el tracking
      // entre navegaciones
    };
  }, []);

  return null;
};

export default HubSpotTracker;